import { env } from '@/lib/env';

/**
 * Format a number as currency using the configured currency symbol
 * @param amount - The numeric amount to format
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted currency string with symbol prefix
 */
export function formatCurrency(amount: number, decimals: number = 2): string {
  return `${env.CURRENCY_SYMBOL}${amount.toFixed(decimals)}`;
}

/**
 * Get the configured currency symbol
 * @returns The currency symbol from environment
 */
export function getCurrencySymbol(): string {
  return env.CURRENCY_SYMBOL;
}
